import React, { useEffect, useState } from 'react'
import { agentConversations } from '../../../assets/data/agentConversations'
import List from './List'
import styles from './Main.module.css'

const Main = () => {

    const [data, setData] = useState<any>()

    useEffect(() => {
        setData(agentConversations)
    }, [])

    return (
        <div className={`${styles.conversationsContainer} bg-white`}>
            {
                data && data.length > 0 ?
                    <div className={styles.conversationListContainer}>
                        <div className={styles.header}>
                            <h6>Conversation Type</h6>
                            <h6>Date taken</h6>
                            <h6>CSAT</h6>
                            <h6>QA Score</h6>
                            <h6>Nytro Rating</h6>
                            <h6>Actions Pending</h6>
                            <h6>Comments</h6>
                            <h6>URL</h6>
                        </div>
                        <List data={data} />
                    </div> :
                    null

            }
        </div>
    )
}

export default Main
